module.exports = __webpack_public_path__ + "img/loading-teatro.fc4e1b1b.jpg";